<!--
  @component Navbar.Row

  A component that represents a horizontal section within the navbar.
  It can contain various navbar elements and supports custom styling and color variants.

  @prop colorVariant - The color variant to apply to the row
  @prop css - Custom CSS styles to apply to the row

  Example:
  <Navbar.Row colorVariant="primary">
    <Navbar.Group>
      <Navbar.Brand href="/">Company Logo</Navbar.Brand>
    </Navbar.Group>
    <Navbar.MenuBar label="Main Navigation">
      <Navbar.Item label="Home" href="/" />
      <Navbar.Item label="Products" href="/products" />
    </Navbar.MenuBar>
  </Navbar.Row>
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { navbarStyles } from '../navbar.styles';
  import { dynamicColorStyles } from '@agapi/ui/panda/utils';
  import type { NavbarRowProps } from '../navbar.types';

  /** Props for the Navbar.Row component. */
  const { children, css: cssProp, colorVariant }: NavbarRowProps = $props();

  /** Classes for the navbar row. */
  const classes = navbarStyles.raw();
</script>

<div
  class={css(classes.row, cssProp)}
  style="
    {colorVariant ? `background-color: ${dynamicColorStyles(colorVariant).backgroundColor};` : ''}
    {colorVariant ? `color: ${dynamicColorStyles(colorVariant).color};` : ''}
  "
>
  {#if children}
    {@render children()}
  {/if}
</div>